<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'advance-search-dialog'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>
      <el-form :model="form" label-position="right">
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Tên công việc" class="formItem">
              <el-input
                v-model="searchForm.taskTitle"
                size="medium"
                class="style-fullWidth input-none__border has-border__bottom"
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Mô tả" class="formItem">
              <el-input
                v-model="searchForm.taskDetail"
                size="medium"
                class="style-fullWidth input-none__border has-border__bottom"
                placeholder="-"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Hạn hoàn thành" class="formItem">
              <el-date-picker
                v-model="deadlineRange"
                type="daterange"
                range-separator=" - "
                start-placeholder="-"
                end-placeholder="-"
                align="bottom"
                format="dd/MM/yyyy"
                class="style-fullWidth input-none__border has-border__bottom"
                size="medium"
                @change="deadlineRangeChanged"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24" v-if="!isDisableAssignerFilter">
            <el-form-item
              label="Người giao"
              class="formItem"
              v-if="checkMenuCVLienQuan()"
            >
              <el-select
                clearable
                class="style-fullWidth input-none__border has-border__bottom"
                v-model="searchForm.assignerUserDeptRoleId"
                filterable
                size="medium"
                placeholder="Gõ để bắt đầu tìm kiếm theo họ tên"
                remote
                :remote-method="remoteSearchAssignerUsers"
              >
                <el-option
                  v-for="item in disPlayAssigners"
                  :key="item.id"
                  :value="item.id"
                  :label="`${item.fullName} (${item.positionName} - ${item.deptName})`"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Người giao" class="formItem" v-else>
              <el-select
                clearable
                class="style-fullWidth input-none__border has-border__bottom"
                v-model="searchForm.assignerUserDeptRoleId"
                filterable
                size="medium"
                placeholder="Người giao"
              >
                <el-option
                  v-for="item in assigners"
                  :key="item.id"
                  :value="item.id"
                  :label="`${item.fullName} (${item.positionName} - ${item.deptName})`"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="24" v-if="!isDisableReceiverFilter">
            <el-form-item
              label="Người thực hiện"
              class="formItem"
              v-if="checkMenuCVLienQuan()"
            >
              <el-select
                clearable
                class="style-fullWidth input-none__border has-border__bottom"
                v-model="searchForm.receiverUserDeptRoleId"
                filterable
                size="medium"
                placeholder="Gõ để bắt đầu tìm kiếm theo họ tên"
                remote
                :remote-method="remoteSearchReceiverUsers"
              >
                <el-option
                  v-for="item in disPlayReceivers"
                  :key="item.id"
                  :value="item.id"
                  :label="`${item.fullName} (${item.positionName} - ${item.deptName})`"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Người thực hiện" class="formItem" v-else>
              <el-select
                clearable
                class="style-fullWidth input-none__border has-border__bottom"
                v-model="searchForm.receiverUserDeptRoleId"
                filterable
                size="medium"
                placeholder="Người thực hiện"
              >
                <el-option
                  v-for="item in receivers"
                  :key="item.id"
                  :value="item.id"
                  :label="`${item.fullName} (${item.positionName} - ${item.deptName})`"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fas fa-search"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset">
          <i class="fas fa-undo"></i>
          &nbsp;Khởi tạo
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import utils from "../../../services/utils";
import h from "../../../services/h";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import CustomDialog from "../../common/custom-dialog";
import constants from "../../../constants";
import departmentService from "../../../services/departmentService";

export default {
  name: "task-advance-search-dialog",
  props: [
    "isOpen",
    "form",
    "isDisableDeptAssignerFilter",
    "isDisableAssignerFilter",
    "isDisableReceiverFilter",
  ],
  components: {
    CustomDialog,
  },

  data() {
    return {
      assigners: [],
      receivers: [],
      departments: [],
      disPlayReceivers: [],
      disPlayAssigners: [],
      deadlineRange: null,
      searchForm: {
        fromDeadline: null,
        toDeadline: null,
        taskTitle: null,
        taskDetail: null,
        assignerUserDeptRoleId: null,
        assignerUserDeptRole: null,
        receiverUserDeptRoleId: null,
      },
    };
  },

  created() {
    this.initForm();
    this.getInitData();
  },

  methods: {
    remoteSearchReceiverUsers(query) {
      if (query) {
        this.disPlayReceivers = h.findAll(this.receivers, (userDeptRoleView) =>
          utils.isUserDeptRoleMatchWithQueryByName(userDeptRoleView, query)
        );
      } else {
        this.disPlayReceivers = [];
      }
    },
    remoteSearchAssignerUsers(query) {
      if (query) {
        this.disPlayAssigners = h.findAll(this.assigners, (userDeptRoleView) =>
          utils.isUserDeptRoleMatchWithQueryByName(userDeptRoleView, query)
        );
      } else {
        this.disPlayAssigners = [];
      }
    },
    getInitData() {
      if (this.checkMenuCVLienQuan()) {
        if (this.searchForm.assignerUserDeptRoleId)
          userDeptRoleViewService
            .findById(this.searchForm.assignerUserDeptRoleId)
            .then((response) => (this.disPlayAssigners = [response.data]));
        if (this.searchForm.receiverUserDeptRoleId)
          userDeptRoleViewService
            .findById(this.searchForm.receiverUserDeptRoleId)
            .then((response) => (this.disPlayReceivers = [response.data]));
      }
      if (!this.checkMenuCVLienQuan()) {
        this.loadAssigners();
        this.loadReceivers();
      } else {
        this.loadDerpartment().then(() => {
          this.loadAssignersAndReceivers();
        });
      }
    },

    checkMenuCVLienQuan() {
      return this.$route.name === "job-index-coordinate";
    },

    deadlineRangeChanged() {
      utils.timeRangeChanged(this.deadlineRange, (from_, to_) => {
        this.searchForm.fromDeadline = from_;
        this.searchForm.toDeadline = to_;
      });
    },

    loadDerpartment() {
      return departmentService.findAll().then((res) => {
        this.departments = res.data.filter((item) => item.id !== "ROOT");
      });
    },

    loadAssignersAndReceivers() {
      return userDeptRoleViewService.findAll().then((response) => {
        this.allUser = response.data.filter(
          (x) =>
            x.status === "active" &&
            x.usersStatus === "active" &&
            x.deptStatus === "active" &&
            x.isDefaultRole
        );
        if (this.$store.getters.userDeptRole.deptId === "TCT") {
          this.assigners = this.allUser
            .filter((item) => item.deptId === "TCT")
            .sort((node1, node2) =>
              utils.compareUserDeptRoleView(node1, node2)
            );
          this.receivers = this.allUser.sort((node1, node2) =>
            utils.compareUserDeptRoleView(node1, node2)
          );
        } else {
          this.assigners = this.allUser
            .filter(
              (x) => this.filterDepartmentAssigners().indexOf(x.deptId) !== -1
            )
            .sort((node1, node2) =>
              utils.compareUserDeptRoleView(node1, node2)
            );
          this.receivers = this.allUser
            .filter(
              (x) => this.filterDepartmentReceiver().indexOf(x.deptId) !== -1
            )
            .sort((node1, node2) =>
              utils.compareUserDeptRoleView(node1, node2)
            );
        }
      });
    },

    // Lọc ra các phòng ban có thể giao cho currentUser
    filterDepartmentAssigners() {
      // PBCN thì lấy ngang cấp và phòng con
      // DVTT thì chỉ lấy từ cùng phòng đó trở xuống
      let newDepartment = [];
      let currentDept = this.departments.find(
        (item) => item.id === this.$store.getters.userDeptRole.deptId
      );
      newDepartment = [currentDept];
      newDepartment.forEach((element) => {
        newDepartment = [
          ...newDepartment,
          this.departments.find((item) => item.id === element.parentId),
          // this.departments.find((item) => item.id === "TCT"),
        ];
      });
      if (!this.checkChiNhanh(currentDept)) {
        newDepartment = [
          ...this.departments.filter(
            (x) =>
              x.parentId === currentDept.parentId &&
              (x.deptType === constants.DEPARTMENT.DEPT_TYPE.PBCN ||
                !x.deptType) &&
              x.id !== currentDept.id
          ),
          ...newDepartment,
        ];
      }
      return newDepartment.map((item) => item.id);
    },

    // Lọc ra các phòng ban currentUser có thể giao
    filterDepartmentReceiver() {
      // PBCN thì lấy ngang cấp và phòng con
      // DVTT thì chỉ lấy từ cùng phòng đó trở xuống
      let newDepartment = [];
      let currentDept = this.departments.find(
        (item) => item.id === this.$store.getters.userDeptRole.deptId
      );
      newDepartment = [currentDept];
      newDepartment.forEach((element) => {
        newDepartment = [
          ...newDepartment,
          ...this.departments.filter((item) => item.parentId === element.id),
        ];
      });
      if (!this.checkChiNhanh(currentDept)) {
        newDepartment = [
          ...this.departments.filter(
            (x) =>
              x.parentId === currentDept.parentId &&
              (x.deptType === constants.DEPARTMENT.DEPT_TYPE.PBCN ||
                !x.deptType) &&
              x.id !== currentDept.id
          ),
          ...newDepartment,
        ];
      }
      return newDepartment.map((item) => item.id);
    },

    checkChiNhanh(currentDept) {
      return (
        currentDept.deptType === constants.DEPARTMENT.DEPT_TYPE.DVTT &&
        currentDept.parentId === "TCT"
      );
    },

    loadAssigners() {
      return userDeptRoleViewService
        .findAllAssignersForTask()
        .then((response) => {
          this.assigners = (
            response.data.filter(
              (x) =>
                x.status === "active" &&
                x.usersStatus === "active" &&
                x.deptStatus === "active" &&
                x.isDefaultRole
            ) || []
          ).sort((node1, node2) => utils.compareUserDeptRoleView(node1, node2));
        });
    },

    loadReceivers() {
      return userDeptRoleViewService
        .findAllReceiversForTaskV2()
        .then((response) => {
          this.receivers = (
            response.data.filter(
              (x) =>
                x.status === "active" &&
                x.usersStatus === "active" &&
                x.deptStatus === "active" &&
                x.isDefaultRole
            ) || []
          ).sort((node1, node2) => utils.compareUserDeptRoleView(node1, node2));
        });
    },

    initForm() {
      this.searchForm.fromDeadline = this.form.fromDeadline;
      this.searchForm.toDeadline = this.form.toDeadline;
      this.searchForm.taskTitle = this.form.taskTitle;
      this.searchForm.taskDetail = this.form.taskDetail;
      this.searchForm.assignerUserDeptRoleId = this.form.assignerUserDeptRoleId;
      this.searchForm.assignerUserDeptRole = this.form.assignerUserDeptRole;
      this.searchForm.receiverUserDeptRoleId = this.form.receiverUserDeptRoleId;
      this.initDeadlineRange();
    },

    initDeadlineRange() {
      this.deadlineRange = utils.initTimeRange(
        this.searchForm.fromDeadline,
        this.searchForm.toDeadline
      );
    },

    search() {
      this.$emit("doSearch", {
        advanceSearchForm: {
          fromDeadline: this.searchForm.fromDeadline,
          toDeadline: this.searchForm.toDeadline,
          taskTitle: this.searchForm.taskTitle,
          taskDetail: this.searchForm.taskDetail,
          assignerUserDeptRoleId: this.searchForm.assignerUserDeptRoleId,
          assignerUserDeptRole: this.searchForm.assignerUserDeptRole,
          receiverUserDeptRoleId: this.searchForm.receiverUserDeptRoleId,
        },
      });
      this.$emit("closeDialog");
    },

    reset() {
      this.searchForm.fromDeadline = null;
      this.searchForm.toDeadline = null;
      this.searchForm.taskTitle = null;
      this.searchForm.taskDetail = null;
      this.searchForm.assignerUserDeptRoleId = null;
      this.searchForm.assignerUserDeptRole = null;
      this.searchForm.receiverUserDeptRoleId = null;
      this.initDeadlineRange();
    },
  },
};
</script>

<style scoped>
.form {
  padding: 12px 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/job/components/advanceSearch.vue